// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1tkPf","buttons":"Footer_buttons__1wruQ"};